import { ContentStatus } from 'enums';

export default function getContentId({ id, eventId, status, isEvent, streams = [], isEventOverride = false } = {}) {
    let content = { id: (streams[0] && streams[0].id) || id };
    // if (streams.length > 1 || isEventOverride || (status === ContentStatus.UPCOMING && (isEvent))) {
    //     content = { eventId: eventId || id };
    // }
    return content;
}



// WEBPACK FOOTER //
// ./app/lib/auth/getContentId.js